import React, { useState } from 'react';
import InventoryManagement from '../InventoryManagement';
import DeviceAssetInformation from '../DeviceAssetInformation';

function Inventory({ refreshList, notification, handleClose }) {
  const [selectedTab, selectTab] = useState(1);
  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-2/5 py-4 px-10 relative mt-6 rounded-3xl">
        <img
          src="assets/img/Close.svg"
          className="absolute top-5 right-10 h-4 cursor-pointer"
          alt=""
          onClick={handleClose}
        />
        {/* <div className="flex">
          <button
            className={`font-bold text-xl cursor-pointer pb-2 focus:outline-none ${
              selectedTab === 1 ? 'text-textBlue1 border-b-4 border-blueBtn' : 'text-parameter opacity-60'
            }`}
            onClick={() => {
              selectTab(1);
            }}
          >
            Inventory Management
          </button>
          <button
            className={`font-bold text-xl cursor-pointer ml-14 pb-2 focus:outline-none  ${
              selectedTab === 2 ? 'text-textBlue1 border-b-4 border-blueBtn' : 'text-parameter opacity-60'
            }`}
          >
            Attach Device To Asset
          </button>
        </div> */}
        <div>
          {selectedTab === 1 ? (
            <InventoryManagement
              openDeviceInfo={() => {
                selectTab(2);
              }}
              notification={notification}
            />
          ) : (
            <DeviceAssetInformation
              refreshList={refreshList}
              openDeviceInfo={() => {
                selectTab(2);
              }}
              notification={notification}
            />
          )}
        </div>

        {/* <div>
          {selectedTab === 1 ? (
            <DeviceAssetInformation
              openDeviceInfo={() => {
                selectTab(1);
              }}
              refreshList={() => refreshList()}
            />
          ) : (
            <InventoryManagement refreshList={refreshList} />
          )}
        </div> */}
      </div>
    </div>
  );
}

export default Inventory;
